import React from 'react';

import { ConfigureProtocolsInlineComponent } from 'app/components/ConfigureProtocolsButton';

export default function ProtocolsConfiguration() {
  return (
    <div
      style={{
        backgroundColor: '#4f504f',
        padding: '16px 1em',
        borderRadius: '4px',
        margin: 'calc(-16px - 0.8em) -0.8em',
      }}
    >
      <ConfigureProtocolsInlineComponent />
    </div>
  );
}
